// Copyright (c) 2016 Deere & Company

import MassChannelCustomerFollowUp from '../../../reports/mass-channel-customer-follow-up/state-connector';

export default {
    component: MassChannelCustomerFollowUp,
    name: 'MASS_CHANNEL_CUSTOMER_FOLLOW_UP',
    path: 'mass-channel-customer-follow-up'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/mass-channel-customer-follow-up.js